import { useState, useContext, createContext } from 'react';
import { Th as ChakraTh, TableColumnHeaderProps, Flex } from '@chakra-ui/react';

const tableHeaderStyles: TableColumnHeaderProps = {
   fontSize: 'lg',
   fontWeight: '500',
   textTransform: 'capitalize',
   px: '2',
   borderBottom: '2px solid',
   borderColor: 'gray.200',
};

const ThStateContext = createContext<{ isHovered: boolean }>({ isHovered: false });

export const Th = ({ children, ...props }: TableColumnHeaderProps) => {
   const [isHovered, setIsHovered] = useState(false);

   return (
      <ChakraTh
         {...tableHeaderStyles}
         {...props}
         onMouseEnter={() => setIsHovered(true)}
         onMouseLeave={() => setIsHovered(false)}
      >
         <ThStateContext.Provider value={{ isHovered }}>
            <Flex alignItems={'center'}>{children}</Flex>
         </ThStateContext.Provider>
      </ChakraTh>
   );
};

export function useThState() {
   return useContext(ThStateContext);
}
